import { createFileRoute } from "@tanstack/react-router";

import WaitlistQrPage from "@/components/WaitlistQrPage";

export const Route = createFileRoute("/waitlist-qr")({
  component: WaitlistQrPage,
});
